import { create } from 'zustand';
import { safeStorage } from './utils';

export type ThemePreference = 'light' | 'dark' | 'system';
const KEY = 'jdap.theme';

function resolve(pref: ThemePreference): 'light' | 'dark' {
  if (pref !== 'system') return pref;
  return typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(pref: ThemePreference): void {
  document.documentElement.classList.toggle('dark', resolve(pref) === 'dark');
}

function initial(): ThemePreference {
  const v = safeStorage.get(KEY);
  return v === 'light' || v === 'dark' || v === 'system' ? v : 'system';
}

interface ThemeState {
  preference: ThemePreference;
  setPreference: (p: ThemePreference) => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  preference: initial(),
  setPreference: (preference) => {
    safeStorage.set(KEY, preference);
    applyTheme(preference);
    set({ preference });
  },
}));
